import React from 'react';
import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';

import { useAppContext } from '@prisjakt/ui-app-context';

import { Row } from '@prisjakt/ui/list/variants';
import { BodySmallText, FontEmphasis } from '@prisjakt/ui/text/variants';
import Currency from '@prisjakt/ui-currency';
import { DiffPercentageCore } from 'src/components/product-card/styles';
import { Price } from '../price';

import { BaseProps } from '../../types';

type Props = Pick<
  BaseProps,
  'price' | 'diffPercentage' | 'priceInclShipping' | 'showFromPrice' | 'store'
>;

export const CompactListCardPrice: React.FC<Props> = props => {
  const {
    price,
    diffPercentage = 0,
    priceInclShipping,
    showFromPrice,
    store,
  } = props;

  const { t } = useAppContext();

  return (
    <PriceContainer>
      <Row>
        {price && (
          <PriceTextWrapper>
            <PriceText>
              {diffPercentage ? (
                <DiffPercentage>-{Math.round(diffPercentage)}%</DiffPercentage>
              ) : null}

              <div>
                {showFromPrice && (
                  <>
                    <BodySmallText emphasis={FontEmphasis.LOW}>
                      {t('product', 'price.from-abbr')}
                    </BodySmallText>{' '}
                  </>
                )}
                <Price
                  price={price}
                  isDeal={Boolean(diffPercentage)}
                  currency={store?.currency}
                />
              </div>
            </PriceText>

            {priceInclShipping ? (
              <BodySmallText emphasis={FontEmphasis.LOW}>
                {t('product', 'price.including-shipping', {
                  price: <Currency price={priceInclShipping} />,
                })}
              </BodySmallText>
            ) : null}
          </PriceTextWrapper>
        )}
      </Row>
    </PriceContainer>
  );
};

export const PriceContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const PriceTextWrapper = styled.div`
  align-items: baseline;
  flex-wrap: wrap;
  flex-direction: column;
  text-align: end;
`;

export const PriceText = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-column-gap: ${layout.measurements.spacing050};
`;

export const DiffPercentage = styled(DiffPercentageCore)`
  margin-right: ${layout.measurements.spacing025};
`;
